export default {
  title: 'Trade Terms Management',

  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Term code, name',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  actions: {
    addTradeTerm: 'Add Trade Term',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  table: {
    termsCode: 'Terms Code',
    termsName: 'Terms Name',
    status: 'Status',
    operation: 'Operation'
  },

  modal: {
    title: 'Add Trade Terms',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} trade terms, {total} available'
  },

  confirm: {
    toggleStatus: 'Are you sure to {action} this trade term?'
  },

  messages: {
    selectToAdd: 'Please select trade terms to add',
    selectToEnable: 'Please select trade terms to enable',
    selectToDisable: 'Please select trade terms to disable',
    loadError: 'Failed to load trade terms data, please try again later',
    searchError: 'Search failed, please try again later',
    platformLoadError: 'Failed to load platform trade terms data, please try again later',
    associateSuccess: 'Successfully associated {count} trade terms',
    associateError: 'Failed to associate trade terms, please try again later',
    statusToggleSuccess: 'Trade term status updated to {status} successfully',
    statusToggleError: 'Failed to toggle status, please try again later',
    batchEnableSuccess: 'Enabled {count} trade terms',
    batchEnableError: 'Batch enable failed, please try again later',
    batchDisableSuccess: 'Disabled {count} trade terms',
    batchDisableError: 'Batch disable failed, please try again later'
  },

  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  }
}